export const GET_CONCIERGE_REQUEST = 'GET_CONCIERGE_REQUEST';
export const GET_CONCIERGE_SUCCESS = 'GET_CONCIERGE_SUCCESS';
export const GET_CONCIERGE_FAILURE = 'GET_CONCIERGE_FAILURE';